import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

const transactions = [
  { name: "Regular Deposit", date: "Mar 15", category: "Others", amount: "+$33.33", color: "#10B981", icon: "dots" },
  { name: "Juan Martin Di Maria", date: "Mar 15", category: "Bills", amount: "-$250.00", color: "#EF4444", icon: "doc" },
  { name: "Juan Martin Di Maria", date: "Mar 15", category: "Bills", amount: "-$3,500.00", color: "#EF4444", icon: "doc" },
  { name: "Comcast Xfinity", date: "Mar 15", category: "Bills", amount: "-$93.75", color: "#EF4444", icon: "doc" },
  { name: "Regular Deposit", date: "Mar 14", category: "Others", amount: "+$6,337.50", color: "#10B981", icon: "dots" },
  { name: "Regular Deposit", date: "Mar 14", category: "Others", amount: "+$48.75", color: "#10B981", icon: "dots" },
];

const spendingData = [
  { month: "Oct", value: 8 },
  { month: "Nov", value: 10 },
  { month: "Dec", value: 8 },
  { month: "Jan", value: 12 },
  { month: "Feb", value: 15 },
  { month: "Mar", value: 85, amount: "$5,365.01" },
];

export const AmericanNewLanding = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    const currentParams = location.search;
    navigate(`/regional-login-americannew-mobile${currentParams}`);
  };

  const handleDetails = () => {
    const currentParams = location.search;
    navigate(`/regional-card_detail-americannew-mobile${currentParams}`);
  };

  return (
    <div className="rnl-landing">
      <div className="rnl-landing-container">
        {/* Header */}
        <div className="rnl-header">
          <div className="rnl-header-content">
            <div className="rnl-header-left">
              <div className="rnl-user-avatar">
                <img src="/img/avatar-placeholder.png" alt="User" onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentNode.innerHTML = '<span>AG</span>';
                }} />
              </div>
              <div className="rnl-welcome-info">
                <span className="rnl-welcome-label" style={{ color: colors.primario }}>Welcome,</span>
                <span className="rnl-welcome-name" style={{ color: colors.primario }}>Avila Leonel Gaston</span>
              </div>
            </div>
            <div className="rnl-header-right">
              <div className="rnl-settings-icon" style={{ backgroundColor: colors.primario }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="white" strokeWidth="2"/>
                  <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="white" strokeWidth="2"/>
                  <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="white" strokeWidth="2"/>
                  <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="white" strokeWidth="2"/>
                </svg>
              </div>
              {colors.url_logo && (
                <img src={colors.url_logo} alt="Logo" className="rnl-header-logo" />
              )}
            </div>
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="rnl-content">
          {/* Account Card */}
          <div className="rnl-account-card" style={{ backgroundColor: colors.primario }}>
            <div className="rnl-account-top">
              <span className="rnl-account-type">Savings Account</span>
              <span className="rnl-account-number">**** **** **** 9674</span>
            </div>
            <div className="rnl-account-balance">
              <span className="rnl-currency">USD</span>
              <span className="rnl-amount">$6,450</span>
              <span className="rnl-cents">.82</span>
            </div>
            <div className="rnl-account-actions">
              <button className="rnl-card-btn" onClick={handleDetails}>Details</button>
              <button className="rnl-card-btn">Send</button>
              <button className="rnl-card-btn">Transfer</button>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="rnl-section">
            <h2 className="rnl-section-title">Quick Actions</h2>
            <div className="rnl-quick-actions">
              <div className="rnl-qa-item">
                <div className="rnl-qa-icon-outline" style={{ borderColor: colors.primario }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke={colors.primario} strokeWidth="2"/>
                    <circle cx="12" cy="12" r="6" stroke={colors.primario} strokeWidth="2"/>
                    <circle cx="12" cy="12" r="2" fill={colors.primario}/>
                  </svg>
                </div>
                <span className="rnl-qa-label">Goals</span>
              </div>
              <div className="rnl-qa-item">
                <div className="rnl-qa-icon-filled" style={{ backgroundColor: '#7C3AED' }}>
                  <svg width="20" height="20" viewBox="0 0 59.1 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M58.7,83.4c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c-2.7-2.8-4.8-6.1-6.4-9.8c-0.2-0.6-0.8-1-1.4-1h-1.3h-5.8H20.6l36.6-46.9c0.2-0.3,0.3-0.6,0.3-1v-9.1c0-0.9-0.7-1.6-1.6-1.6H38.8h-0.7h-2V0.8c0-0.4-0.4-0.8-0.8-0.8H35h-0.3H23.9h-0.4h-0.3c-0.4,0-0.8,0.4-0.8,0.8v13.1h-2.8H19H3.1c-0.9,0-1.6,0.7-1.6,1.6V26c0,0.9,0.7,1.6,1.6,1.6h33.6L0.3,74C0.1,74.3,0,74.7,0,75v9.5c0,0.9,0.7,1.6,1.6,1.6h20.9v13.1c0,0.4,0.4,0.8,0.8,0.8h0.3H24h10.8H35h0.4c0.4,0,0.8-0.4,0.8-0.8V86.1H45h11.3h1.3c0.6,0,1.2-0.4,1.4-1C59.3,84.6,59.1,83.9,58.7,83.4" fill="white"/>
                  </svg>
                </div>
                <span className="rnl-qa-label">Zelle</span>
              </div>
              <div className="rnl-qa-item">
                <div className="rnl-qa-icon-outline" style={{ borderColor: colors.primario }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke={colors.primario} strokeWidth="2"/>
                    <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" stroke={colors.primario} strokeWidth="2"/>
                  </svg>
                </div>
                <span className="rnl-qa-label">Global</span>
              </div>
              <div className="rnl-qa-item">
                <div className="rnl-qa-icon-outline" style={{ borderColor: colors.primario }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" stroke={colors.primario} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <span className="rnl-qa-label">Checks</span>
              </div>
              <div className="rnl-qa-item">
                <div className="rnl-qa-icon-outline" style={{ borderColor: colors.primario }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke={colors.primario} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <span className="rnl-qa-label">Transfers</span>
              </div>
              <div className="rnl-qa-item">
                <div className="rnl-qa-icon-outline" style={{ borderColor: colors.primario }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="1" fill={colors.primario}/>
                    <circle cx="6" cy="12" r="1" fill={colors.primario}/>
                    <circle cx="18" cy="12" r="1" fill={colors.primario}/>
                  </svg>
                </div>
                <span className="rnl-qa-label">More</span>
              </div>
            </div>
          </div>

          {/* Send To */}
          <div className="rnl-section">
            <div className="rnl-section-header">
              <h2 className="rnl-section-title">Send to</h2>
              <span className="rnl-section-link" style={{ color: colors.primario }}>See all</span>
            </div>
            <div className="rnl-send-to">
              <div className="rnl-send-avatar">
                <div className="rnl-send-icon-photo">
                  <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Juan" />
                </div>
                <span className="rnl-send-name">Juan</span>
              </div>
              <div className="rnl-send-avatar">
                <div className="rnl-send-icon-photo">
                  <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Maria" />
                </div>
                <span className="rnl-send-name">Maria</span>
              </div>
              <div className="rnl-send-avatar">
                <div className="rnl-send-icon-photo">
                  <img src="https://randomuser.me/api/portraits/men/75.jpg" alt="Carlos" />
                </div>
                <span className="rnl-send-name">Carlos</span>
              </div>
              <div className="rnl-send-avatar">
                <div className="rnl-send-icon-photo">
                  <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Ana" />
                </div>
                <span className="rnl-send-name">Ana</span>
              </div>
              <div className="rnl-send-avatar">
                <div className="rnl-send-icon-add">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 5v14M5 12h14" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <span className="rnl-send-name">Add new</span>
              </div>
            </div>
          </div>

          {/* Spending */}
          <div className="rnl-section">
            <div className="rnl-section-header">
              <h2 className="rnl-section-title">Spending</h2>
              <span className="rnl-section-link" style={{ color: colors.primario }}>Details</span>
            </div>
            <div className="rnl-spending-card">
              <span className="rnl-spending-subtitle">By Month</span>
              <div className="rnl-chart">
                {spendingData.map((item, index) => (
                  <div key={index} className="rnl-chart-col">
                    {item.amount && (
                      <span className="rnl-chart-amount">{item.amount}</span>
                    )}
                    <div className="rnl-chart-bar-wrap">
                      <div
                        className="rnl-chart-bar"
                        style={{
                          height: `${item.value}%`,
                          backgroundColor: index === spendingData.length - 1 ? colors.primario : '#D1D5DB',
                        }}
                      ></div>
                    </div>
                    <span
                      className="rnl-chart-label"
                      style={{
                        fontWeight: index === spendingData.length - 1 ? '700' : '400',
                        color: index === spendingData.length - 1 ? '#1a1a2e' : '#9CA3AF',
                      }}
                    >
                      {item.month}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Recent Transactions */}
          <div className="rnl-section">
            <div className="rnl-section-header">
              <h2 className="rnl-section-title" style={{ color: colors.primario }}>Recent Transactions</h2>
              <span className="rnl-section-link">See all</span>
            </div>
            <div className="rnl-transactions-card">
              {transactions.map((tx, index) => (
                <div key={index} className="rnl-tx-item">
                  <div className="rnl-tx-icon" style={{ backgroundColor: colors.primario }}>
                    {tx.icon === "dots" ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="1.5" fill="white"/>
                        <circle cx="6" cy="12" r="1.5" fill="white"/>
                        <circle cx="18" cy="12" r="1.5" fill="white"/>
                      </svg>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="4" y="2" width="16" height="20" rx="2" stroke="white" strokeWidth="2"/>
                        <path d="M8 6h8M8 10h8M8 14h4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    )}
                  </div>
                  <div className="rnl-tx-info">
                    <span className="rnl-tx-name">{tx.name}</span>
                    <span className="rnl-tx-date">{tx.date} · {tx.category}</span>
                  </div>
                  <span className="rnl-tx-amount" style={{ color: tx.color }}>{tx.amount}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Navigation */}
        <div className="rnl-bottom-nav">
          <div className="rnl-nav-item active">
            <div className="rnl-nav-icon-wrap">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" fill={colors.primario} stroke={colors.primario} strokeWidth="2"/>
              </svg>
            </div>
            <span style={{ color: colors.primario }}>Home</span>
          </div>
          <div className="rnl-nav-item">
            <div className="rnl-nav-icon-circle" style={{ backgroundColor: '#7C3AED' }}>
              <svg width="18" height="18" viewBox="0 0 59.1 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M58.7,83.4c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c-2.7-2.8-4.8-6.1-6.4-9.8c-0.2-0.6-0.8-1-1.4-1h-1.3h-5.8H20.6l36.6-46.9c0.2-0.3,0.3-0.6,0.3-1v-9.1c0-0.9-0.7-1.6-1.6-1.6H38.8h-0.7h-2V0.8c0-0.4-0.4-0.8-0.8-0.8H35h-0.3H23.9h-0.4h-0.3c-0.4,0-0.8,0.4-0.8,0.8v13.1h-2.8H19H3.1c-0.9,0-1.6,0.7-1.6,1.6V26c0,0.9,0.7,1.6,1.6,1.6h33.6L0.3,74C0.1,74.3,0,74.7,0,75v9.5c0,0.9,0.7,1.6,1.6,1.6h20.9v13.1c0,0.4,0.4,0.8,0.8,0.8h0.3H24h10.8H35h0.4c0.4,0,0.8-0.4,0.8-0.8V86.1H45h11.3h1.3c0.6,0,1.2-0.4,1.4-1C59.3,84.6,59.1,83.9,58.7,83.4" fill="white"/>
              </svg>
            </div>
            <span>Zelle</span>
          </div>
          <div className="rnl-nav-item">
            <div className="rnl-nav-icon-wrap">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span>Deposit</span>
          </div>
          <div className="rnl-nav-item">
            <div className="rnl-nav-icon-wrap">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#9CA3AF" strokeWidth="2"/>
                <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" stroke="#9CA3AF" strokeWidth="2"/>
              </svg>
            </div>
            <span>Global</span>
          </div>
          <div className="rnl-nav-item" onClick={handleLogout} style={{ cursor: 'pointer' }}>
            <div className="rnl-nav-icon-wrap rnl-nav-logout">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span style={{ color: '#EF4444' }}>Log out</span>
          </div>
        </div>
      </div>
    </div>
  );
};
